import { render, staticRenderFns } from "./SubCategorias.vue?vue&type=template&id=c0767ca4&scoped=true&"
import script from "./SubCategorias.vue?vue&type=script&lang=js&"
export * from "./SubCategorias.vue?vue&type=script&lang=js&"
import style0 from "./SubCategorias.vue?vue&type=style&index=0&id=c0767ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0767ca4",
  null
  
)

export default component.exports